import { ACCOUNT_ROUTES, EXTERNAL_ROUTES } from 'App/constants'

const getRoute = (ctaText: string): string => {
  switch (ctaText) {
    case 'viewAllRewards':
      return ACCOUNT_ROUTES.AllRewardsList.path
    case 'infoPagePerks':
      return EXTERNAL_ROUTES.clubInfoPage
    case 'pointsHistory':
      return ACCOUNT_ROUTES.PointsHistory?.path
    case 'infoPage':
      return EXTERNAL_ROUTES.clubInfoPage
    default:
      return ''
  }
}

export default getRoute
